import { render } from "./Decoration10Slow.vue?vue&type=template&id=a1a0aec0&scoped=true"
import script from "./Decoration10Slow.vue?vue&type=script&lang=js"
export * from "./Decoration10Slow.vue?vue&type=script&lang=js"

import "./Decoration10Slow.vue?vue&type=style&index=0&id=a1a0aec0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a0aec0"]])

export default __exports__